module.exports = __webpack_public_path__ + "img/centro-civico.aba41872.svg";